import { render } from "./schools-zipcode.vue?vue&type=template&id=643983be"
import script from "./schools-zipcode.js?vue&type=script&lang=js"
export * from "./schools-zipcode.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__